import React, { useEffect, useState } from "react";
import { WpCategory, WpProject_Gallery_Category } from "codegen";
import "./FilterDropdown.scss";
import { navigate } from "gatsby-link";

interface FilterDropdownProps {
  categories?: (WpCategory | WpProject_Gallery_Category)[] & any; // Account for Intrinsic Types
}

/**
 * Select component which will navigate to the category pages
 *
 * @param categories - Items to be displays within the dropdown, would be a post category
 * @returns Search functionality through posts or pages that are passed down
 *
 */
export const FilterDropdown = ({ categories = [] }: FilterDropdownProps): JSX.Element => {
  const [currentPath, setCurrentPath] = useState(typeof window !== "undefined" ? window.location.pathname : null);
  const [postType, setPostType] = useState("");

  // on load gets the URL location, for example /blog/ or /projects/
  // will need tweaking if the URL structure is slightly different
  useEffect(() => {
    let pathArray = currentPath.split("/");
    pathArray = pathArray.filter(Boolean);

    setPostType(pathArray[0]);
  }, [currentPath]);
  return (
    <select
      className="filter--dropdown"
      value={currentPath}
      onChange={(event) => {
        event.preventDefault();
        navigate(event.target.value);
      }}
    >
      <option value={`/${postType}/`} className="filter--dropdown--item">
        All
      </option>
      {/* Maps through all categories and returns the ones which aren't "uncategorised" */}
      {Object.keys(categories).length > 0 &&
        categories.flatMap((item, index) => {
          return item.slug !== "uncategorised" ? (
            <option value={`/${postType}/${item.slug}/`} key={`${item.id}-${index}`} className="filter--dropdown--item">
              {item.name}
            </option>
          ) : null;
        })}
    </select>
  );
};
